$shm_hitalama_map_widget_float_form_string $mol_string
